// Business (work) email validation — mirrors backend services/_shared/business_email.py.
// Blocks free/personal consumer providers and common disposable domains.

export const GENERIC_EMAIL_DOMAINS = new Set([
  'gmail.com', 'googlemail.com',
  'outlook.com', 'outlook.co.uk', 'hotmail.com', 'hotmail.co.uk', 'hotmail.fr',
  'live.com', 'live.co.uk', 'msn.com', 'windowslive.com',
  'yahoo.com', 'yahoo.co.uk', 'yahoo.co.in', 'yahoo.ca', 'yahoo.com.au',
  'yahoo.fr', 'yahoo.de', 'yahoo.es', 'yahoo.it', 'ymail.com', 'rocketmail.com',
  'aol.com', 'aim.com',
  'icloud.com', 'me.com', 'mac.com',
  'protonmail.com', 'proton.me', 'pm.me',
  'gmx.com', 'gmx.net', 'gmx.de', 'gmx.co.uk', 'mail.com', 'email.com',
  'zoho.com', 'zohomail.com', 'yandex.com', 'yandex.ru', 'hey.com',
  'fastmail.com', 'fastmail.fm', 'tutanota.com', 'tuta.io', 'hushmail.com',
  'rediffmail.com', 'sbcglobal.net', 'att.net', 'verizon.net', 'comcast.net',
  'cox.net', 'bellsouth.net', 'btinternet.com', 'sky.com', 'virginmedia.com',
  'web.de', 't-online.de', 'freenet.de', 'orange.fr', 'wanadoo.fr', 'laposte.net',
  'libero.it', 'virgilio.it', 'naver.com', 'qq.com', '163.com', '126.com',
  'sina.com', 'foxmail.com',
]);

export const DISPOSABLE_EMAIL_DOMAINS = new Set([
  'mailinator.com', '10minutemail.com', 'guerrillamail.com', 'guerrillamail.info',
  'sharklasers.com', 'yopmail.com', 'yopmail.fr', 'temp-mail.org', 'tempmail.com',
  'trashmail.com', 'getnada.com', 'nada.email', 'dispostable.com', 'maildrop.cc',
  'throwawaymail.com', 'fakeinbox.com', 'mailnesia.com', 'mytemp.email',
  'tempmailo.com', 'moakt.com', 'mohmal.com', 'spam4.me', 'grr.la',
  'emailondeck.com', 'mailcatch.com', 'inboxkitten.com', 'burnermail.io',
]);

export const BUSINESS_EMAIL_MESSAGE =
  "Please use your business (work) email address. Free or personal email providers (e.g. gmail.com, outlook.com, yahoo.com) aren't accepted here — enter the email at your company's domain.";

export function emailDomain(email) {
  const e = (email || '').toLowerCase().trim();
  return e.includes('@') ? e.split('@')[1].trim() : '';
}

export function isGenericEmail(email, policy) {
  const domain = emailDomain(email);
  if (!domain) return false;
  const norm = (arr) => new Set((arr || []).map((d) => String(d).toLowerCase().trim().replace(/^@/, '')));
  const allowed = norm(policy?.allowed_domains);
  const blocked = norm(policy?.blocked_domains);
  if (allowed.has(domain)) return false; // force-allow wins
  if (blocked.has(domain)) return true;
  return GENERIC_EMAIL_DOMAINS.has(domain) || DISPOSABLE_EMAIL_DOMAINS.has(domain);
}
